import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fetchQuote = async (config) => {
  const { data } = await axios.post(`${API}/quote`, { config });
  return data;
};

export const createCheckout = async (items, customer) => {
  const payload = {
    items: items.map((i) => ({ config: i.config, quantity: i.qty })),
    origin_url: window.location.origin,
    customer,
  };
  const { data } = await axios.post(`${API}/checkout/session`, payload);
  return data;
};

export const getCheckoutStatus = async (sessionId) => {
  const { data } = await axios.get(`${API}/checkout/status/${sessionId}`);
  return data;
};
